/* eslint-disable no-console */
import toast from "react-hot-toast";
import { client } from "."; // ← cliente oficial

export const saveUsuario = async (usuario) => {
  try {
    const { data, error } = await client.from("usuarios").insert(usuario).select();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error("Error saveUsuario:", error);
    toast.error("Error al crear usuario");
    throw error;
  }
};
